(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-mobile-hat-campaigns"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.egbhReady) return;
      root.dataset.egbhReady = '1';
      const isHome = root.hasAttribute('data-egbh-carousel');
      document.documentElement.classList.add(isHome ? 'egbh-home-active' : 'egbh-collection-active');
      if (!isHome) {
        if (root.dataset.egbhCampaign) document.documentElement.classList.add(`egbh-collection-${root.dataset.egbhCampaign}`);
        return;
      }
      const track = root.querySelector('.egbh__track');
      const slides = [...root.querySelectorAll('[data-egbh-slide]')];
      if (slides.length < 2) return;
      const dots = root.querySelector('[data-egbh-dots]');
      let index = 0;
      let raf = 0;
      dots.innerHTML = slides.map((slide, i) => `<button class="egbh__dot" type="button" data-egbh-dot="${i}" aria-label="Show ${slide.dataset.egbhSlide}" aria-current="${i === 0}"></button>`).join('');
      const hydrate = slide => {
        if (!slide) return;
        slide.querySelectorAll('source[data-egbh-srcset]').forEach(source => {
          source.srcset = source.dataset.egbhSrcset;
          delete source.dataset.egbhSrcset;
        });
        slide.querySelectorAll('img[data-egbh-src]').forEach(img => {
          img.loading = 'eager';
          img.src = img.dataset.egbhSrc;
          delete img.dataset.egbhSrc;
        });
      };
      const state = n => {
        index = (n + slides.length) % slides.length;
        hydrate(slides[index]);
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });
        root.querySelectorAll('[data-egbh-dot]').forEach((dot, i) => dot.setAttribute('aria-current', i === index));
      };
      const show = n => {
        hydrate(slides[(n + slides.length) % slides.length]);
        state(n);
        track.scrollTo({ left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
      };
      root.addEventListener('click', e => {
        const dot = e.target.closest('[data-egbh-dot]');
        if (dot) show(Number(dot.dataset.egbhDot));
        if (e.target.closest('[data-egbh-prev]')) show(index - 1);
        if (e.target.closest('[data-egbh-next]')) show(index + 1);
      });
      track.addEventListener('pointerdown', () => {
        hydrate(slides[(index + 1) % slides.length]);
        hydrate(slides[(index - 1 + slides.length) % slides.length]);
      }, { passive: true });
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => state(Math.round(track.scrollLeft / track.clientWidth)));
      }, { passive: true });
      track.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      });
      addEventListener('resize', () => track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' }), { passive: true });
      state(0);
    };
    const all = () => document.querySelectorAll('.egbh').forEach(init);
    all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-preorder-hat-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.egph');
    sections.forEach((section) => {
      const dialog = section.querySelector('[data-egph-dialog]');
      const dialogImage = section.querySelector('[data-egph-dialog-image]');
      const dialogTitle = section.querySelector('[data-egph-dialog-title]');
      if (!dialog || !dialogImage || !dialogTitle) return;

      section.addEventListener('click', (event) => {
        if (event.target.closest('[data-egph-top]')) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        if (event.target.closest('[data-egph-chat]')) {
          event.preventDefault();
          event.stopPropagation();
          const chat = document.querySelector('shopify-chat');
          const shell = chat && chat.shadowRoot;
          const runtime = shell && shell.querySelector('shopify-agent-runtime');
          const activator = shell && (shell.querySelector('[part="activator"]') || (runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector('[part="activator"]')));
          if (activator) activator.click();
          else {
            const footerChat = document.querySelector('a.footer-chat-link');
            if (footerChat) footerChat.click();
          }
          return;
        }
        const opener = event.target.closest('[data-egph-open]');
        if (opener && opener.dataset.egphSrc) {
          dialogImage.src = opener.dataset.egphSrc;
          dialogImage.alt = opener.dataset.egphTitle || '';
          dialogTitle.textContent = opener.dataset.egphTitle || '';
          dialog.showModal();
          return;
        }
        if (event.target.closest('[data-egph-close]')) dialog.close();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-reviews-speed-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.egbhReady) return;
      root.dataset.egbhReady = '1';
      const isHome = root.hasAttribute('data-egbh-carousel');
      document.documentElement.classList.add(isHome ? 'egbh-home-active' : 'egbh-collection-active');
      if (!isHome) {
        if (root.dataset.egbhCampaign) document.documentElement.classList.add(`egbh-collection-${root.dataset.egbhCampaign}`);
        return;
      }
      const track = root.querySelector('.egbh__track');
      const slides = [...root.querySelectorAll('[data-egbh-slide]')];
      const dots = root.querySelector('[data-egbh-dots]');
      let index = 0;
      let raf = 0;
      dots.innerHTML = slides.map((slide, i) => `<button class="egbh__dot" type="button" data-egbh-dot="${i}" aria-label="Show ${slide.dataset.egbhSlide}" aria-current="${i === 0}"></button>`).join('');
      const hydrate = slide => {
        if (!slide) return;
        slide.querySelectorAll('source[data-egbh-srcset]').forEach(source => {
          source.srcset = source.dataset.egbhSrcset;
          delete source.dataset.egbhSrcset;
        });
        slide.querySelectorAll('img[data-egbh-src]').forEach(img => {
          img.loading = 'eager';
          img.src = img.dataset.egbhSrc;
          delete img.dataset.egbhSrc;
        });
      };
      const state = n => {
        index = (n + slides.length) % slides.length;
        hydrate(slides[index]);
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });
        root.querySelectorAll('[data-egbh-dot]').forEach((dot, i) => dot.setAttribute('aria-current', i === index));
      };
      const show = n => {
        hydrate(slides[(n + slides.length) % slides.length]);
        state(n);
        track.scrollTo({ left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
      };
      root.addEventListener('click', e => {
        const dot = e.target.closest('[data-egbh-dot]');
        if (dot) show(Number(dot.dataset.egbhDot));
        if (e.target.closest('[data-egbh-prev]')) show(index - 1);
        if (e.target.closest('[data-egbh-next]')) show(index + 1);
      });
      track.addEventListener('pointerdown', () => {
        hydrate(slides[(index + 1) % slides.length]);
        hydrate(slides[(index - 1 + slides.length) % slides.length]);
      }, { passive: true });
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => state(Math.round(track.scrollLeft / track.clientWidth)));
      }, { passive: true });
      track.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      });
      addEventListener('resize', () => track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' }), { passive: true });
      state(0);
    };
    const all = () => document.querySelectorAll('.egbh').forEach(init);
    all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();
})();
